import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const fetchAllSalebills = (filters = {}) => {
  const query_string = new URLSearchParams(filters).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/salebill?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchOneSalebill = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/salebill/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchLastTraderSaleBillNumber = () => {
  return axios
    .get(
      `${process.env.REACT_APP_BASE_URL}/salebill/last-trader-sale-number`,
      { headers: authHeader() }
    )
    .then((res) => res.data.data)
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const createSalebill = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/salebill/`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const updateSalebill = (id, data) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/salebill/${id}`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const deleteSalebill = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_BASE_URL}/salebill/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const checkSalebillDuplicate = ({ salebillno, excludeSalebillId } = {}) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/salebill/check-duplicate`, {
      salebillno,
      excludeSalebillId,
    }, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      console.error("Error checking salebill duplicate:", err);
      throw err;
    });
};

export const getPackingListDetails = (params) => {
  const query_string = new URLSearchParams(params).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/salebill/packing-list-items?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const generateSalebillRegisterReport = (reportData) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/salebill/register-report`, reportData, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating sale bill register report");
      throw err;
    });
};

export const generateSalebillRegisterReportFull = (reportData) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/salebill/register-report-full`, reportData, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating sale bill register report (full)");
      throw err;
    });
};

export const generateSalebillRegisterCSV = (reportData) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/salebill/register-report-csv`, reportData, {
      headers: authHeader(),
      responseType: 'blob', // Important for file download
    })
    .then((res) => {
      // Create a blob from the response
      const blob = new Blob([res.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'register.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      toast.success("CSV file downloaded successfully");
      return { success: true };
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating sale bill register CSV");
      throw err;
    });
};

export const generateSalebillRegisterCSVFull = (reportData) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/salebill/register-report-csv-full`, reportData, {
      headers: authHeader(),
      responseType: 'blob', // Important for file download
    })
    .then((res) => {
      // Create a blob from the response
      const blob = new Blob([res.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'register.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      toast.success("CSV file downloaded successfully");
      return { success: true };
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating sale bill register CSV (full)");
      throw err;
    });
};

export const viewSaleBillReport = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/salebill/view-report/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating sale bill report");
      throw err;
    });
};

export const generatePaymentDueAgingReport = (reportData) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/salebill/payment-due-aging-report`, reportData, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating payment due aging report");
      throw err;
    });
};

/**
 * Update Sale Bill - Comprehensive sale bill update (all types: DIR, STK, PL, ORD)
 * @param {number} id - Sale bill ID
 * @param {Object} data - Sale bill data matching backend validation schema
 */
export const updateSaleBill = (id, data) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/salebill/${id}`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      if (res.data.billsuccess || res.data.success) {
        toast.success(res.data.msg || "Sale bill updated successfully");
      }
      return res.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error updating sale bill");
      throw err;
    });
};

/**
 * Create Sale Bill - Comprehensive sale bill creation (all types: DIR, STK, PL, ORD)
 * @param {Object} data - Sale bill data matching backend validation schema
 */
export const createSaleBill = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/salebill`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      if (res.data.billsuccess) {
        toast.success(res.data.msg || "Sale bill created successfully");
      }
      return res.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error creating sale bill");
      throw err;
    });
};

export const fetchCndnItemRowDetails = (params) => {
  const query_string = new URLSearchParams(params).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/salebill/cndn-item-details?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      console.error("Error fetching CNDN item details:", err);
      throw err;
    });
};

export const generateAnalysisItemsReport = (reportData) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/salebill/analysis-items-report`, reportData, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating analysis items report");
      throw err;
    });
};

export const generateLedgerReport = (reportData) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/salebill/ledger-report`, reportData, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating ledger report");
      throw err;
    });
};

export const generateJournalBookReport = (reportData) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/salebill/journal-book-report`, reportData, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating journal book report");
      throw err;
    });
};

export const generateTrialBalanceReport = (reportData = {}) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/salebill/trial-balance-report`, reportData, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating trial balance report");
      throw err;
    });
};

const generateFinancialStatement = (endpoint, errorMessage) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/salebill/${endpoint}`, {}, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || errorMessage);
      throw err;
    });
};

export const generateBalanceSheetReport = () => {
  return generateFinancialStatement(
    "balance-sheet-report",
    "Error generating balance sheet"
  );
};

export const generateProfitLossReport = () => {
  return generateFinancialStatement(
    "profit-loss-report",
    "Error generating profit and loss statement"
  );
};
